module.exports = __webpack_public_path__ + "img/as-cares.7708b409.jpg";